export default "__VITE_ASSET__dae9f37b__"